// extracted by mini-css-extract-plugin
export var active = "_cs-7";
export var container = "_cs-0";
export var evenWidth = "_cs-4";
export var large = "_cs-5";
export var outlet = "_cs-8";
export var slide = "_cs-2";
export var small = "_cs-6";
export var tab = "_cs-3";
export var tabs = "_cs-1";